/** @deprecated This component is not directly imported by any domain code. Only used internally by DetailForm. */
import { cn } from '@/lib/utils';
import { Textarea } from '@/shared/components/ui/textarea';
import type { TextAreaProps } from './TextArea.types';

const TextArea = ({
  id,
  value,
  name,
  placeholder,
  onChange,
  disabled = false,
  className = '',
  maxLength,
}: TextAreaProps): JSX.Element => {
  return (
    <div className="flex flex-col gap-2 w-full h-full">
      <Textarea
        id={id}
        name={name}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        disabled={disabled}
        className={cn(className)}
        maxLength={maxLength}
      />
    </div>
  );
};

export default TextArea;
